jQuery(document).ready(function($) {
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                 if ($(node).attr('role') == 'dialog') {
                    $(node).find('form').submit(function() {
                       var btn =  $(node).find('button.form-submit');
                       $(btn).prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i>');
                    });
                 }
            });
        });
    });

    observer.observe($("body").get(0), {
        childList: true
    });
});